import { ReportDailyMetric, SEARCH_PARAMS_VALUES } from '../../constants/app.constants';
import { createTourSection } from '../tours/helpers';

export const FETCH_RHL_CLIENTS_THUNK_TYPE = 'FETCH_RHL_CLIENTS_THUNK_TYPE';
export const FETCH_RHL_CLIENTS_ERROR_MSG = 'Error fetching RHL clients';

export const FETCH_PCYM_COMPANY_STATS_THUNK_TYPE = 'FETCH_PCYM_COMPANY_STATS_THUNK_TYPE';
export const FETCH_YTD_COMPANY_STATS_THUNK_TYPE = 'FETCH_YTD_COMPANY_STATS_THUNK_TYPE';
export const FETCH_TOP_AGENTS_THUNK_TYPE = 'FETCH_TOP_AGENTS_THUNK_TYPE';
export const FETCH_TOP_AGENTS_THUNK_ERROR = 'Error fetching top recovery agents';
export const FETCH_TOP_AGENTS_VIEW_ALL_THUNK_TYPE = 'FETCH_TOP_AGENTS_VIEW_ALL_THUNK_TYPE';
export const FETCH_TOP_AGENTS_VIEW_ALL_THUNK_ERROR = 'Error fetching top recovery agents view all';
export const FETCH_DAILY_VIEW_STATS_THUNK_TYPE = 'FETCH_DAILY_VIEW_STATS_THUNK_TYPE';
export const FETCH_MTD_REPOSSESSED_THUNK_TYPE = 'FETCH_MTD_REPOSSESSED_THUNK_TYPE';
export const FETCH_MTD_ASSIGNED_THUNK_TYPE = 'FETCH_MTD_ASSIGNED_THUNK_TYPE';

export const FETCH_CLIENT_LIST_WITH_LIENHOLDERS = 'FETCH_CLIENT_LIST_WITH_LIENHOLDERS';
export const FETCH_CLIENT_LIST_WITH_LIENHOLDERS_ERROR_MSG = 'Error fetching client list with lienholders';

export const FETCH_LENDER_DETAIL = 'FETCH_NEW_CLIENT_DETAILS_LENDER';
export const FETCH_LENDER_DETAIL_ERROR_MSG = 'Error fetching lender details';
export const FETCH_LIENHOLDER_DETAIL = 'FETCH_NEW_CLIENT_DETAILS_LIENHOLDER';
export const FETCH_LIENHOLDER_DETAIL_ERROR_MSG = 'Error fetching lienholder details';
export const FETCH_LIENHOLDER_LENDER_DETAIL = 'FETCH_NEW_CLIENT_DETAILS_LIENHOLDER_LENDER';
export const FETCH_LIENHOLDER_LENDER_DETAIL_ERROR_MSG = 'Error fetching lienholder with lender details';

export const CREATE_TRR_LENDER = 'CREATE_TRR_LENDER';
export const CREATE_TRR_LENDER_ERROR_MSG = 'Error creating TRR lender';
export const UPDATE_TRR_LENDER = 'UPDATE_TRR_LENDER';
export const UPDATE_TRR_LENDER_ERROR_MSG = 'Error updating TRR lender';

export const CREATE_TRR_LIENHOLDER = 'CREATE_TRR_LIENHOLDER';
export const CREATE_TRR_LIENHOLDER_ERROR_MSG = 'Error creating TRR lienholder';
export const UPDATE_TRR_LIENHOLDER = 'UPDATE_TRR_LIENHOLDER';
export const UPDATE_TRR_LIENHOLDER_ERROR_MSG = 'Error updating TRR lienholder';

export const UPSERT_TRR_LENDER = 'UPSERT_TRR_LENDER';
export const UPSERT_TRR_LENDER_ERROR_MSG = 'Error updating the Target Recovery Rate';
export const UPSERT_TRR_LIENHOLDER = 'UPSERT_TRR_LIENHOLDER';
export const UPSERT_TRR_LIENHOLDER_ERROR_MSG = 'Error updating the Target Recovery Rate';

const sharedClientDetails = {
  assignmentsCard: {
    __typename: '',
    current: 0,
    previous: 0,
    percent: 0,
    arrow: '',
  },
  repossessionsCard: {
    __typename: '',
    current: 0,
    previous: 0,
    percent: 0,
    arrow: '',
  },
  missedRepossessionsCard: {
    __typename: '',
    current: 0,
    previous: 0,
    percent: 0,
    arrow: '',
  },
  assignments: {
    __typename: '',
    currentYear: 0,
    previousYear: 0,
    previousTwoYears: 0,
    previousThreeYears: 0,
  },
  repossessions: {
    __typename: '',
    currentYear: 0,
    previousYear: 0,
    previousTwoYears: 0,
    previousThreeYears: 0,
  },
};

export const REPORTS_INITIAL_STATE = {
  rhlClientList: [],
  rhlClientListLoading: true,
  pcymCompanyStats: {},
  pcymCompanyStatsLoading: true,
  pcymCompanyStatsFirstLoading: true,
  ytdCompanyStats: {},
  ytdCompanyStatsLoading: true,
  ytdCompanyStatsFirstLoading: true,
  topAgents: {
    mostRepossessions: [],
    mostInvoluntary: [],
    mostVoluntary: [],
  },
  topAgentsLoading: true,
  topAgentsFirstLoading: true,
  topSpotters: {
    totalSpotted: [],
    secured: [],
    closed: [],
  },
  topSpottersLoading: true,
  topSpottersFirstLoading: true,
  dailyViewStats: {},
  dailyViewStatsLoading: true,
  dailyViewStatsFirstLoading: true,
  mtdCurrentRepossessed: 0,
  mtdCurrentRepossessedLoading: true,
  mtdCurrentRepossessedFirstLoading: true,
  mtdPreviousRepossessed: 0,
  mtdPreviousRepossessedLoading: true,
  mtdPreviousRepossessedFirstLoading: true,
  mtdCurrentAssigned: 0,
  mtdCurrentAssignedLoading: true,
  mtdCurrentAssignedFirstLoading: true,
  mtdPreviousAssigned: 0,
  mtdPreviousAssignedLoading: true,
  mtdPreviousAssignedFirstLoading: true,
  // mtdytdCompanyUncategorized: {
  //   mtd: { assigned: 0, respossessed: 0 },
  //   ytd: { assigned: 0, respossessed: 0 },
  // },
  // mtdytdCompanyUncategorizedLoading: true,
  // mtdytdCompanyUncategorizedFirstLoading: true,
  clientListData: [],
  isClientListLoading: true,
  // newClientListDetails
  lenderDetailsData: {
    lenderClientId: '',
    lenderClientName: '',
    ...sharedClientDetails,
  },
  lenderDetailsLoading: true,
  lienholderDetailsData: {
    lienholderClientId: '',
    lienholderClientName: '',
    ...sharedClientDetails,
  },
  lienholderDetailsLoading: true,
  lienholderLenderDetailsData: {
    lenderClientId: '',
    lenderClientName: '',
    lienholderClientId: '',
    lienholderClientName: '',
    ...sharedClientDetails,
  },
  lienholderLenderDetailsLoading: true,
  // TRR Lender
  targetRecoveryRateLoading: false,
  isLenderEditTRRModalOpen: false,
  isLienholderEditTRRModalOpen: false,
  // Top recovery agents view all
  topAgentsViewAll: [],
  topAgentsViewAllLoading: true,
};

export const CARDS_INFO = [
  {
    id: createTourSection('daily-reports', 'new-assignments'),
    header: 'New Assignments',
    value: ReportDailyMetric.NEW_ASSIGNMENTS,
  },
  {
    id: createTourSection('daily-reports', 'accounts-not-checked'),
    header: 'Accounts Not Checked',
    value: ReportDailyMetric.ACCOUNT_NOT_CHECKED,
  },
  {
    id: createTourSection('daily-reports', 'total-repossessions'),
    header: 'Total Repossessions',
    value: ReportDailyMetric.TOTAL_REPOSSESSIONS,
  },
  {
    id: createTourSection('daily-reports', 'confirmed-not-repossessed'),
    header: 'Repossession Hit List',
    value: ReportDailyMetric.REPOSSESSIONS_HIT_LIST,
  },
  {
    id: createTourSection('daily-reports', 'live-hits'),
    header: 'Total Live Hits',
    value: ReportDailyMetric.LIVE_HITS,
  },
  {
    id: createTourSection('daily-reports', 'scans'),
    header: 'Total Unique Scans',
    value: ReportDailyMetric.SCANS,
  },
  {
    id: createTourSection('daily-reports', 'spotted'),
    header: 'Total Spotted',
    value: ReportDailyMetric.SPOTTED,
  },
  {
    id: createTourSection('daily-reports', 'spotted-not-secured'),
    header: 'Spotted Not Secured',
    value: ReportDailyMetric.SPOTTED_NOT_SECURED,
  },
  {
    id: createTourSection('daily-reports', 'live-hits-not-secured'),
    header: 'Live Hits Not Secured',
    value: ReportDailyMetric.LIVE_HITS_NOT_SECURED,
  },
  {
    id: createTourSection('daily-reports', 'check-ins'),
    header: 'Total Check Ins',
    value: ReportDailyMetric.CHECK_INS,
  },
];

export const CARDS_INFO_V2 = [
  {
    id: createTourSection('daily-reports', 'new-assignments'),
    header: 'New Assignments',
    value: ReportDailyMetric.NEW_ASSIGNMENTS,
  },
  {
    id: createTourSection('daily-reports', 'accounts-not-checked'),
    header: 'Accounts Not Checked',
    value: ReportDailyMetric.ACCOUNT_NOT_CHECKED,
  },
  {
    id: createTourSection('daily-reports', 'check-ins'),
    header: 'Total Check Ins',
    value: ReportDailyMetric.CHECK_INS,
  },
  {
    id: createTourSection('daily-reports', 'daily-recovery-rate'),
    header: 'Daily Recovery Rate',
    value: ReportDailyMetric.DAILY_RECOVERY_RATE,
  },
  {
    id: createTourSection('daily-reports', 'total-repossessions'),
    header: 'Total Repossessions',
    value: ReportDailyMetric.TOTAL_REPOSSESSIONS,
  },
  {
    id: createTourSection('daily-reports', 'confirmed-not-repossessed'),
    header: 'Repossession Hit List',
    value: ReportDailyMetric.REPOSSESSIONS_HIT_LIST,
  },
  {
    id: createTourSection('daily-reports', 'scans'),
    header: 'Total Unique Scans',
    value: ReportDailyMetric.SCANS,
  },
  {
    id: createTourSection('daily-reports', 'live-hits'),
    header: 'Total Live Hits',
    value: ReportDailyMetric.LIVE_HITS,
  },
  {
    id: createTourSection('daily-reports', 'spotted'),
    header: 'Total Spotted',
    value: ReportDailyMetric.SPOTTED,
  },
  {
    id: createTourSection('daily-reports', 'spotted-not-secured'),
    header: 'Spotted Not Secured',
    value: ReportDailyMetric.SPOTTED_NOT_SECURED,
  },
  {
    id: createTourSection('daily-reports', 'spotting-alerts'),
    header: 'Spotting Alerts',
    value: ReportDailyMetric.SPOTTED_VEHICLES,
  },
  {
    id: createTourSection('daily-reports', 'live-hits-not-secured'),
    header: 'Live Hits Not Secured',
    value: ReportDailyMetric.LIVE_HITS_NOT_SECURED,
  },
  {
    id: createTourSection('daily-reports', 'oversightt-repossessions'),
    header: 'Oversightt Repossessions',
    value: ReportDailyMetric.OVERSIGHTT_REPOSSESSION,
  },
];

export enum DateRangeSelector {
  MTD = 'MTD',
  YTD = 'YTD',
  CUSTOM = 'CUSTOM',
}

export enum ReportMenuOption {
  ALL_TIME = 'all-times',
  DAILY = 'daily',
  DAILY_MAP = 'daily-map',
}

/**
 * @deprecated Use DayMenuOption from insightt-shared instead
 */
export enum DayMenuOption {
  YESTERDAY = 'yesterday',
  TODAY = 'today',
}

export const LIVE_HITS_TABS = [
  {
    value: SEARCH_PARAMS_VALUES.hitsTypes.all,
    label: 'All Hits',
  },
  { value: SEARCH_PARAMS_VALUES.hitsTypes.direct, label: 'Direct Hits' },
  { value: SEARCH_PARAMS_VALUES.hitsTypes.lpr, label: 'LPR Hits' },
];

export const pollIntervalDataReport = 40000;
